module.exports = __webpack_public_path__ + "img/cp-logo.1acb893c.png";